import { Injectable } from '@angular/core';
import { NgxSpinnerService } from '../components/ngx-spinner/ngx-spinner.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  stophideSpinner_: boolean = true;
  constructor(
    private spinner: NgxSpinnerService
  ) { }
  public showSpinner(){
    this.spinner.show();
  }
  public hideSpinner(){   
      this.spinner.hide();
    // setTimeout(() => {
    //   /** spinner ends after 10 seconds */
    //   this.spinner.hide();
    // }, 10000);
  }

  stophideSpinner(val) {
    this.stophideSpinner_ = val;
  }
}
